import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/HybridStores';

export const HYBRID_STORES_MERCHANTS_GET_SUCCESS = `${rootActionPath}/merchants/GET_${SUCCESS_SUFFIX}`;
export const HYBRID_STORES_MERCHANTS_GET_FAILURE = `${rootActionPath}/merchants/GET_${FAILURE_SUFFIX}`;

export const HYBRID_STORES_VIEW = `${rootActionPath}/VIEW`;
